import { useAreaNumUnit } from 'src/utils/hooks/useAreaNumUnit';
import { QuotePlaceholderMap } from 'src/pages/OfferPage/QuotePlaceholderMap/QuotePlaceholderMap';
import { ts } from 'src/utils/translate';

export const TableHeader = (props: any) => {
  const {
    tablesEnabled,
    table,
    guessed,
    roomMapsEnabled,
    infoButton = false,
    measurementSystem
  } = props;

  const { area, airSpace } = useAreaNumUnit(table, measurementSystem);

  const areTablesEnabled =
    tablesEnabled && table && (!!table.rows.length || guessed);
  const areRoomAndMapsShown =
    roomMapsEnabled && table && table.entitytype === "roomtable_count";

  const url = ts('site_lang', 'hu-HU') === "hu-HU"
      ? "https://uplan.io/hu/munkadij/"
      : "https://www.uplan.io/labour-cost";

  return (
    <div className="room-header-container" >
      {areTablesEnabled || areRoomAndMapsShown ? (
        <h3 id={table.entitytype} style={{ fontWeight: 300 }}>
          {table.floorname ? `${table.floorname} - ` : ""}
          {table.name}

          {area.num ? (
            <span className="quote-room-area">
              {" "}
              [{area.num} {area.unit}
              <sup>2</sup>]
            </span>
          ) : null}
          {airSpace.num ? (
            <span className="quote-room-airspace">
              {" "}
              [{airSpace.num} {airSpace.unit}
              <sup>3</sup>]
            </span>
          ) : null}

          {table.unit_sum ? (
            <span className="quote-room-airspace">
              {" "}
              [ {table.unit_sum} unit ]
            </span>
          ) : null}

          {infoButton ? (
            <a
              href={url}
              target="_blank"
              style={{ color: "var(--uplan-blue)", paddingLeft: 5 }}
            >
              <i
                className="fa fa-info-circle"
                id="contacts-explanation"
                title={url}
                data-toggle="tooltip"
                data-placement="right"
              ></i>
            </a>
          ) : null}
        </h3>
      ) : null}

      {table.entitytype === "roomtable_count" && roomMapsEnabled ? (
        <QuotePlaceholderMap height="500" cls="quote-roomSVG" />
      ) : null}
    </div>
  );
};
